import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ToastProvider } from '@clari/ui'
import { Landing } from '@/pages/Landing'
import { BusinessModel } from '@/pages/BusinessModel'
import { Signup } from '@/pages/auth/Signup'
import { Login } from '@/pages/auth/Login'
import { VerifyEmail } from '@/pages/auth/VerifyEmail'
import { ForgotPassword } from '@/pages/auth/ForgotPassword'
import { ResetPassword } from '@/pages/auth/ResetPassword'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { AppLayout } from '@/components/AppLayout'
import { CookieConsent } from '@/components/CookieConsent'
import { Dashboard } from '@/pages/app/Dashboard'
import { Security } from '@/pages/app/settings/Security'
import { AccountHealth } from '@/pages/app/AccountHealth'
import { Account } from '@/pages/app/Account'
import { Transactions } from '@/pages/app/Transactions'
import { TransactionDetail } from '@/pages/app/TransactionDetail'
import { Transfer } from '@/pages/app/Transfer'
import { TransferSuccess } from '@/pages/app/TransferSuccess'
import { Fx } from '@/pages/app/Fx'
import { Cards } from '@/pages/app/Cards'
import { CardNew } from '@/pages/app/CardNew'
import { CardDetail } from '@/pages/app/CardDetail'
import { Kyc } from '@/pages/app/onboarding/Kyc'
import { KycResult } from '@/pages/app/onboarding/KycResult'
import { AccountOnboarding } from '@/pages/app/onboarding/AccountOnboarding'
import { OnboardingCallback } from '@/pages/onboarding/Callback'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/business-model" element={<BusinessModel />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            {/* Swan OAuth redirect target (Dashboard-registered URL). */}
            <Route path="/onboarding/callback" element={<OnboardingCallback />} />

            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="account" element={<Account />} />
              <Route path="account/health" element={<AccountHealth />} />
              <Route path="transactions" element={<Transactions />} />
              <Route path="transactions/:id" element={<TransactionDetail />} />
              <Route path="transfer" element={<Transfer />} />
              <Route path="transfer/success" element={<TransferSuccess />} />
              <Route path="fx" element={<Fx />} />
              <Route path="cards" element={<Cards />} />
              <Route path="cards/new" element={<CardNew />} />
              <Route path="cards/:id" element={<CardDetail />} />
              <Route path="security" element={<Security />} />
              <Route path="onboarding/account" element={<AccountOnboarding />} />
              <Route path="onboarding/kyc" element={<Kyc />} />
              <Route path="onboarding/kyc/pending" element={<KycResult status="pending" />} />
              <Route path="onboarding/kyc/approved" element={<KycResult status="approved" />} />
              <Route path="onboarding/kyc/rejected" element={<KycResult status="rejected" />} />
            </Route>
          </Routes>
          <CookieConsent />
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  )
}
